(function () {
  function initTravelStaySection(root) {
    var aid = root.dataset.stay22Aid;
    if (!aid) return;

    var mapFrame = root.querySelector('[data-stay22-map]');
    var mapLabel = root.querySelector('[data-map-location-label]');
    var stay22Fallback = root.querySelector('[data-stay22-fallback]');
    var tabButtons = root.querySelectorAll('[data-travel-tab]');
    var panels = root.querySelectorAll('[data-travel-panel]');
    var campaign = root.dataset.stay22Campaign || 'movemybicycle_travel_page';
    var defaultAddress = root.dataset.defaultMapAddress || 'South Africa';
    var currency = (root.dataset.stay22Currency || '').trim();

    if (!mapFrame) return;

    function setActiveTab(tab) {
      tabButtons.forEach(function (btn) {
        var isActive = btn.dataset.travelTab === tab;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.travelPanel !== tab;
      });
    }

    function buildStay22Src(address) {
      var params = new URLSearchParams({
        aid: aid,
        campaign: campaign,
        address: address
      });
      if (currency) params.set('currency', currency);
      return 'https://www.stay22.com/embed/gm?' + params.toString();
    }

    function initMap() {
      if (mapLabel) {
        mapLabel.textContent = 'Search and book stays on the map';
      }
      if (stay22Fallback) stay22Fallback.hidden = true;
      mapFrame.hidden = false;
      mapFrame.src = buildStay22Src(defaultAddress);
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveTab(btn.dataset.travelTab);
      });
    });

    setActiveTab('flights');
    initMap();
  }

  function boot() {
    document.querySelectorAll('[data-travel-stay-section]').forEach(initTravelStaySection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-travel-stay-section]');
    if (root) initTravelStaySection(root);
  });
})();
